<template>
  <a-card title="模板场景管理">
    <a-space>
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;">
        <a-form-item label="标题" name="title">
          <a-input placeholder="标题" v-model:value="formSearch.title" />
        </a-form-item>
         <a-form-item  label="地区" name="region_code">
          <a-select
            :allowClear="true"
            style="width: 100px;"
            v-model:value="formSearch.region_code"
            :options="NationCodes"
          />
        </a-form-item>
        <a-form-item label="状态" name="status">
          <a-select
            style="width: 100px;"
            v-model:value="formSearch.status"
            :options="statusOptions"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
          >
            搜索
          </a-button>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            @click="handleCreate"
          >
            新建
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>

    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;" />
    <a-table
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource"
      :columns="columns"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <template #operator_id="{ record }">
        <Username :user_id="record.operator_id" />
      </template>
      <template #region_code="{ record }">
        <RegionCode :region_code="record.region_code" />
      </template>
      <template #cover="{ record }">
        <a-image
          style="width: 100px;"
          :src="rawImage(record.cover)"
          width="100"
        />
      </template>
      <template #sorted="{ record }">
        <a-input-group compact style="width: 130px;">
          <a-input v-model:value="record.sorted" style="width: 60px;" />
          <a-button type="primary" @click="handleModifySort(record)">设置</a-button>
        </a-input-group>
      </template>
      <template #status="{ record }">
        <a-tag v-if="record.status == 1" color="green">已上线</a-tag>
        <a-tag v-if="record.status == 0" color="gray">已下线</a-tag>
        <a-tag v-if="record.status == 2" color="yellow">预览中</a-tag>
      </template>
      <template #action="{ record }">
        <a-space>
          <a-button @click="handleModifyStatus(record, 1)" v-if="record.status == 2" type="primary">上线</a-button>
          <a-button @click="handleModifyStatus(record, 0)" v-if="record.status != 0" danger>下线</a-button>
          <a-button @click="handleModifyStatus(record, 2)" v-if="record.status ==0" warning>沙盒</a-button>
          <a-button @click="handleUpdate(record)">编辑</a-button>
          <a-button @click="handleViewTemplates(record)">查看模板</a-button>
          <a-popconfirm
            title="确定删除吗?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a-button danger>删除</a-button>
          </a-popconfirm>
        </a-space>
        
      </template>
    </a-table>

    <a-modal v-model:open="openDia" :title="formRecord.id == 0 ? '新建模板场景' : '编辑模板场景'" @cancel="resetForm" @ok="handleConfirm" :confirm-loading="loading">
      <a-form :label-col="{ span: 8 }" :model="formRecord" style="margin: 10px auto;" :rules="rules" ref="formRef">
        <a-form-item required label="标题" name="title">
          <a-input placeholder="标题" v-model:value="formRecord.title" />
        </a-form-item>
        <a-form-item label="国际化标题" name="title_i18n">
          <Inputi18nInline showTitle="true" v-model:valid="formRecord.title_i18n_valid" v-model:value="formRecord.title_i18n" />
        </a-form-item>
        <a-form-item required label="封面" name="cover">
          <Upload v-model:imageUrl="formRecord.cover" />
          <a-input placeholder="封面URL" v-model:value="formRecord.cover" />
          <p><a target="_blank" href="/home/creation/tools">使用动图</a></p>
        </a-form-item>
        <a-form-item label="动画前景图" name="cover_blind">
          <Upload v-model:imageUrl="formRecord.cover_blind" />
          <a-input placeholder="动画前景图URL" v-model:value="formRecord.cover_blind" />
        </a-form-item>
        <a-form-item label="模板IDs" name="template_ids">
          <a-input placeholder="模板IDs，逗号分隔" v-model:value="formRecord.template_ids" />
        </a-form-item>
        <a-form-item required label="排序" name="sorted">
          <a-input placeholder="排序" v-model:value="formRecord.sorted" type="number" />
        </a-form-item>
        <a-form-item label="来源" name="source">
          <a-input placeholder="来源" v-model:value="formRecord.source" />
        </a-form-item>
        <a-form-item required label="地区" name="region_code">
          <a-select
            style="width: 100px;"
            v-model:value="formRecord.region_code"
            :options="NationCodes"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue'
import { message } from 'ant-design-vue'
import request from '@/utils/request'
import Upload from '@/components/Upload.vue'
import Username from '@/components/Username.vue'
import RegionCode from '@/components/RegionCode.vue'
import {NationCodes} from '@/utils/macro'
import Inputi18nInline from '@/components/Inputi18nInline.vue'
import { generateRandomString } from '@/utils/string'
import { thumbnail, rawImage, removeHost } from '@/utils/image'

const DefaultRecord = {
  "id": 0,
  "title": "",
  "title_i18n": "",
  "title_i18n_valid": false,
  "cover": "",
  "cover_blind": "",
  "template_ids": "",
  "sorted": 100,
  "source": "",
  "region_code": "",
  "status": 0
}

export default defineComponent({
  components: {
    Upload,Username,Inputi18nInline,RegionCode
  },
  data() {
    return {
      NationCodes,
      loading: false,
      openDia: false,
      dataSource: [],
      formRecord: {
        ...DefaultRecord
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'change' },
        ],
        cover: [
          { required: true, message: '请输入封面', trigger: 'change' },
        ],
        sorted: [
          { required: true, message: '请输入排序', trigger: 'change' },
        ],
      },
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已下线',
          value: '0'
        },
        {
          label: '测试环境',
          value: '1'
        },
        {
          label: '已上线',
          value: '2'
        },
      ],
      formSearch: {
        title: '',
        status: '',
        region_code: '',
      },
    }
  },
  mounted() {
    this.handleTableChange()
  },
  methods: {
    async handleConfirm() {
      this.loading = true
      try {
        this.formRecord.cover = removeHost(this.formRecord.cover)
        this.formRecord.cover_blind = removeHost(this.formRecord.cover_blind)
        if (!this.formRecord.title_i18n_valid) {
          message.error('请填写国际化标题')
          return false
        }
        if (this.formRecord.id) {
          await request.put(`/api/template_scenes/${this.formRecord.id}`, {
            title: this.formRecord.title,
            title_i18n: this.formRecord.title_i18n,
            cover: this.formRecord.cover,
            cover_blind: this.formRecord.cover_blind,
            template_ids: this.formRecord.template_ids,
            sorted: parseInt(this.formRecord.sorted),
            source: this.formRecord.source,
            region_code: this.formRecord.region_code
          })
        } else {
          await request.post('/api/template_scenes/', {
            title: this.formRecord.title,
            title_i18n: this.formRecord.title_i18n,
            cover: this.formRecord.cover,
            cover_blind: this.formRecord.cover_blind,
            template_ids: this.formRecord.template_ids,
            sorted: parseInt(this.formRecord.sorted),
            source: this.formRecord.source,
            region_code: this.formRecord.region_code
          })
        }
        message.success(this.formRecord.id ? '编辑成功' : '创建成功')
        this.openDia = false
        this.handleTableChange()
      } catch (error) {
        message.error('操作失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleCreate() {
      this.openDia = true
      const i18nkey =`scene.title.${generateRandomString()}`
      console.log(i18nkey)
      this.formRecord = { ...DefaultRecord, title_i18n: i18nkey, title_i18n_valid: false }
    },
    handleUpdate(record) {
      this.openDia = true
      if (record.title_i18n) {
        record.title_i18n_valid = true
      }
      this.formRecord = { ...record }
    },
    async handleDelete(record) {
      this.loading = true
      try {
        await request.delete(`/api/template_scenes/${record.id}`)
        message.success('删除成功')
        this.handleTableChange()
      } catch (error) {
        message.error('删除失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async handleModifySort(record) {
      this.loading = true
      try {
        await request.put(`/api/template_scenes/${record.id}`, {
          sorted: parseInt(record.sorted)
        })
        message.success('排序更新成功')
        this.handleTableChange()
      } catch (error) {
        message.error('排序更新失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async handleModifyStatus(record, status) {
      this.loading = true
      try {
        await request.put(`/api/template_scenes/${record.id}`, {
          status: parseInt(status)
        })
        message.success('状态更新成功')
        this.handleTableChange()
      } catch (error) {
        message.error('状态更新失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleViewTemplates(record) {
      this.$router.push(`/template_scene/${record.id}/templates`)
    },
    resetForm() {
      this.formRecord = { ...DefaultRecord}
      this.$refs.formRef.resetFields()
    },
    async handleTableChange(pagination = { current: 1, pageSize: 20 }) {
      this.loading = true
      try {
        const rsp = await request.get('/api/template_scenes/', {
          offset: (pagination.current - 1) * pagination.pageSize,
          limit: pagination.pageSize,
          ...this.formSearch
        })
        
        if (rsp && rsp.data) {
          this.dataSource = rsp.data.list || []
          for (let v of this.dataSource) {
            v.cover = rawImage(v.cover)
            v.cover_blind = rawImage(v.cover_blind)
          }
          if (rsp.data.pagination) {
            this.noticeMessage = `共 ${rsp.data.pagination.total || 0} 条`
            this.pagination.total = rsp.data.pagination.total || 0
          } else {
            this.noticeMessage = '共 0 条'
            this.pagination.total = 0
          }
        } else {
          this.dataSource = []
          this.noticeMessage = '共 0 条'
          this.pagination.total = 0
        }
        this.pagination.current = pagination.current
        this.pagination.pageSize = pagination.pageSize
      } catch (error) {
        console.error('获取数据失败:', error)
        this.dataSource = []
        this.noticeMessage = '共 0 条'
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
  },
  setup() {
    return {
      thumbnail,
      rawImage,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '标题',
          dataIndex: 'title',
          key: 'title',
        },
        // {
        //   title: '国际化标题',
        //   dataIndex: 'title_i18n',
        //   key: 'title_i18n',
        // },
        {
          title: '封面',
          dataIndex: 'cover',
          key: 'cover',
          slots: { customRender: 'cover' },
        },
        {
          title: '地区',
          dataIndex: 'region_code',
          key: 'region_code',
          slots: { customRender: 'region_code' },
        },
        {
          title: '排序',
          slots: { customRender: 'sorted' },
          width: 130,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          slots: { customRender: 'status' },
        },
        {
          title: '来源',
          dataIndex: 'source',
          key: 'source',
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'created_at',
        //   key: 'created_at',
        // },
        {
          title: '修改时间',
          dataIndex: 'updated_at',
          key: 'updated_at',
        },
        {
          title: '操作人ID',
          dataIndex: 'operator_id',
          key: 'operator_id',
          slots: {
            customRender: 'operator_id'
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    }
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>